import { createActions, createReducer } from 'reduxsauce';

// Define Action
const { Types, Creators } = createActions({
  getQuestionnaireInfo: ['questionnaireId', 'classroomId', 'scope'],
  getQuestionnaireInfoSuccess: null,
  getEdsToken: null,
  getEdsTokenSuccess: null,
  select: ['selected'],
  restore: ['data'],
});

export const Creator = Creators;
export const Type = Types;

// Define Initial State
const INITIAL_STATE = {
  questionnaireId: '',
  name: '',
  submitedCount: 0,
  config: {},
  token: '',
};
// Define Reducer
export default createReducer(INITIAL_STATE, {
  [Types.GET_QUESTIONNAIRE_INFO_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    name: action.name,
    submitedCount: action.submitedCount,
  }),
  [Types.RESTORE]: (state = INITIAL_STATE, action) => ({
    ...state,
    ...action.data,
  }),
  [Types.GET_EDS_TOKEN_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    token: action.token,
  }),
});
